
import * as React from 'react';
import Box from '@mui/material/Box';
import CardContent from '@mui/material/CardContent';
import { Audio, encodeUrl } from './Model';
import ReactAudioPlayer from 'react-audio-player';


export function AudioListItem(props: { item: Audio }) {
    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', width: '90%' }}>
            <CardContent sx={{ flex: 'auto' }}>
                <ReactAudioPlayer src={encodeUrl(props.item.url)} controls
                style={{
                    width: "100%",
                }} />
            </CardContent>
        </Box>
    );
}
